<template>
  <!-- Dialog -->

  <v-dialog v-model="viewModel.dialog.value" persistent max-width="600px">
    <v-card>
      <!-- Title Section -->
      <v-card-title class="d-flex justify-between align-center">
        <span class="text-subtitle-1 font-weight-bold"> Canales de Pago </span>
        <v-spacer></v-spacer>
        <v-btn variant="flat" icon @click="viewModel.closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Account List -->
      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row dense>
            <v-col cols="12">
              <v-card-text class="px-0 pt-0">
                Estas son nuestras cuentas disponibles.
              </v-card-text>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              v-for="account in viewModel.accounts.value"
              :key="account.id"
            >
              <v-card
                border
                flat
                class="pa-4"
                style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
              >
                <v-row>
                  <v-col cols="10">
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ account.nom_banco }}
                    </div>
                    <div class="text-subtitle-2 text-gray-600">
                      <strong>CTA:</strong> {{ account.numcuenta }}
                    </div>
                    <!--  <div class="text-body-2 text-gray-600">
                      CCI: {{ account.cci }}
                    </div> -->
                  </v-col>
                  <v-col cols="2" class="d-flex align-center justify-end">
                    <v-btn
                      variant="flat"
                      icon
                      @click="viewModel.copyAccount(account)"
                      :aria-label="'Copiar cuenta de ' + account.nom_banco"
                    >
                      <v-icon color="primary">mdi-content-copy</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { defineExpose } from "vue";
import AccountsDialogViewModel from "@/viewmodels/dialogs/AccountsDialogViewModel";
import { Account } from "@/models/Account";

const viewModel = new AccountsDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
defineExpose({
  openDialog: (accountsData: Account[]) => viewModel.openDialog(accountsData),
  closeDialog: () => viewModel.closeDialog(),
});
</script>
